// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading_loading__SCF1r","loading-animation":"loading_loading-animation__2uQEe"};